import React, { useCallback, useState } from "react";
import { toast } from "react-toastify";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import baseUrl from "../../../../api/baseUrl";
import {
  APPOINTMENT_TIME_GAP_OPTIONS,
  getStoredAppointmentTimeGap,
  isValidAppointmentTimeGap,
  setStoredAppointmentTimeGap,
  type AppointmentTimeGapMinutes,
} from "../../../appointment/makeappointment/calender/newAppointmentForm";

function AppointmentSlotDurationSetting() {
  const [timeGap, setTimeGap] = useState<AppointmentTimeGapMinutes>(() =>
    getStoredAppointmentTimeGap()
  );
  const [saving, setSaving] = useState(false);

  const handleSelect = useCallback(
    async (gap: AppointmentTimeGapMinutes) => {
      if (saving || gap === timeGap) return;
      setSaving(true);
      try {
        await baseUrl.post("/clinic/addTimeDurationData", {
          timeDuration: String(gap),
        });
        setTimeGap(gap);
        setStoredAppointmentTimeGap(gap);
        toast.success(`Appointment slot duration set to ${gap} minutes`);
      } catch {
        toast.error("Failed to save appointment slot duration");
      } finally {
        setSaving(false);
      }
    },
    [saving, timeGap]
  );

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-2 min-w-0">
          <AccessTimeIcon
            className="text-primary shrink-0 mt-0.5"
            sx={{ fontSize: 20 }}
          />
          <div>
            <h3 className="text-sm font-semibold text-slate-900 dark:text-slate-100">
              Appointment slot duration
            </h3>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
              Default time step when booking appointments on the calendar
            </p>
          </div>
        </div>
        <div
          className="flex items-center gap-1.5 shrink-0"
          role="group"
          aria-label="Appointment slot duration"
          aria-busy={saving}
        >
          {APPOINTMENT_TIME_GAP_OPTIONS.map((gap) => (
            <button
              key={gap}
              type="button"
              disabled={saving}
              onClick={() => {
                if (isValidAppointmentTimeGap(gap)) handleSelect(gap);
              }}
              className={`min-w-[3rem] rounded-lg px-3 py-2 text-sm font-semibold tabular-nums transition-all disabled:opacity-60 disabled:cursor-not-allowed ${
                timeGap === gap
                  ? "bg-primary text-white shadow-sm shadow-primary/25"
                  : "bg-slate-50 border border-slate-200/90 text-slate-700 hover:border-primary/30 hover:bg-primary/5 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-200"
              }`}
            >
              {gap}m
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AppointmentSlotDurationSetting;
